<style scoped>
    .header{
        display: inline-block;
        vertical-align: middle;
        font-size: 24px;
    }
    .margin-l-r {
        margin: 0 10px;
    }
</style>
<template>
  <div>
    <div class="line text-center">
      <Select
        v-model="params.team_id"
        class="margin-l-r"
        placeholder="团队"
        style="width: 100px"
        @on-change="doSearch"
      >
        <Option :value="0">
          所有团队
        </Option>
        <Option
          v-for="team in teams"
          :key="team.id"
          :value="team.id"
        >
          {{ team.name }}
        </Option>
      </Select>
      <Select
        v-model.number="params.flow_node_id"
        placeholder="选择节点"
        style="width: 100px"
        class="margin-l-r"
        @on-change="doSearch"
      >
        <Option :value="-1">
          所有节点
        </Option>
        <Option
          v-for="(flow_node, index) in flow_nodes"
          :key="flow_node.id"
          :value="flow_node.id"
        >
          {{ flow_node.name }}
        </Option>
      </Select>
      <Select
        v-model.number="params.user_flow_node_status"
        placeholder="节点状态"
        style="width: 100px"
        class="margin-l-r"
        @on-change="doSearch"
      >
        <Option :value="-1">
          所有状态
        </Option>
        <Option :value="0">
          进行中
        </Option>
        <Option :value="1">
          完成/通过
        </Option>
      </Select>
    </div>
    <div class="line text-center">
      <span class="header margin-l-r">招聘需求</span>
      <i-input
        v-model="params.search"
        style="width: 180px"
        class="margin-l-r"
        placeholder="输入关键字搜索"
        @on-enter="doSearch()"
      />
      <Ajaxbtn
        ref="searchBtn"
        class="margin-l-r"
        :url="query_url"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
        @finally="handleFinally"
      />
    </div>
    <div class="line">
      <Table
        size="small"
        :columns="columns"
        :data="recruit_needs"
        :loading="loading"
      />
    </div>
    <div class="line paginate-fix-bottom">
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
    <Editor
      ref="editor"
      @update="updateRecruitNeed"
    />
  </div>
</template>
<script route="/recruit/recruit">
  import BaseList from './mixins/base_list';
  import FlowUtil from '../../libs/flow_util';
  import Editor from './components/editor';
  export default {
    /* router_info_start */
    router_info: '/recruit/recruit',
    /* router_info_end */

    components: {Editor},
    mixins: [BaseList],
    data() {
      return {
        query_url: Util.api.query_recruit_need,
        params: {
          per_page: 10,
          page: 1,
          search: '',
          team_id: 0,
          flow_node_id: -1,
          user_flow_node_status: -1
        },
        flow_nodes: []
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      columns() {
        const columns = Util.clone(this.base_columns);
        columns.push({
          title: '操作',
          align: 'center',
          width: 75,
          // fixed: 'right',
          render: (h, params) => {
            const row = params.row;
            const items = [];
            items.push(h('DropdownItem', {
              props:{name: 'edit'}
            }, '编辑'));
            items.push(h('DropdownItem', {
              props:{name: 'delete', divided: true}
            }, '废弃'));
            return h('Dropdown', {
              props: {
                trigger: 'click',
                placement: 'left'
              },
              on: {
                'on-click': (event_name) => {
                  this.handleEvent(event_name, row, params.index);
                }
              }
            }, [
              h('Button', [
                h('span', ' 操作'),
              ]),
              h('DropdownMenu', {
                slot: 'list'
              }, items)
            ]);
          }
        });
        return columns;
      }
    },
    created() {
      this.getFlowInfo();
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      getFlowInfo() {
        Util.ajax.get(Util.api.get_flow_by_link_model, {
          params: {
            link_model: 'RecruitNeed'
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.flow_nodes = data.nodes;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      test() {
        Util.ajax.get('api_url', {
          params: {
            //
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            //成功
          } else {
            //失败
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          // always executed
        });
      }
    }
  }
</script>
